import Prestadores from "./svgprestadores.vue";
import Validacao from "./svgvalidacao.vue";
import Arquivo from "./svgarquivo.vue";
import RecursosProprios from "./svgrecursosproprios.vue";

export default {
  data() {
    return {
      ArquivoSvg: Arquivo,
      PrestadoresSvg: Prestadores,
      ValidacaoSvg: Validacao,
      RecursosPropriosSvg: RecursosProprios
    };
  }
};
